// BusinessInvoice.tsx
import { BaseService } from '../../core/BaseService';
import { PaginationParams } from '../../type';
import {
  AssignUnassignAllRequest,
  AssignUnassignAllResponse,
  AssignUnassignInvoiceRequest,
  AssignUnassignResponse,
  ControlMultiNotificationRequest,
  ControlMultiNotificationResponse,
  ControlNotificationRequest,
  ControlNotificationResponse,
  GetBusinessInvoiceResponse,
  GetEventSubTypesMappingResponse,
  GetEventTypesByParentIdResponse,
  GetNotificationEventSubTypesResponse,
  GetNotificationEventTypesResponse,
} from './interface';

export class AccountSettingsProfile extends BaseService {
  async getBusinessInvoice(params: PaginationParams & { businessId?: number }) {
    return this.get<GetBusinessInvoiceResponse>(`${this.apiUrl}/api/invoicetemplates/bybusinessid`, params);
  }

  async assignInvoice(req: AssignUnassignInvoiceRequest) {
    return this.post<AssignUnassignResponse, AssignUnassignInvoiceRequest>(
      `${this.apiUrl}/api/businesses/template/assign`,
      req
    );
  }

  async unassignInvoice(req: AssignUnassignInvoiceRequest) {
    return this.put<AssignUnassignResponse, AssignUnassignInvoiceRequest>(
      `${this.apiUrl}/api/businesses/template/unassign`,
      req
    );
  }

  async assignAllInvoices(req: AssignUnassignAllRequest) {
    return this.post<AssignUnassignAllResponse, AssignUnassignAllRequest>(
      `${this.apiUrl}/api/businesses/template/assignall`,
      req
    );
  }

  async unassignAllInvoices(req: AssignUnassignAllRequest) {
    return this.put<AssignUnassignAllResponse, AssignUnassignAllRequest>(
      `${this.apiUrl}/api/businesses/template/unassignall`,
      req
    );
  }

  async getNotificationEventTypes(params: PaginationParams) {
    return this.get<GetNotificationEventTypesResponse>(`${this.apiUrl}/api/eventtypes/paged`, params);
  }

  async getEventTypesByParentId(parentId: number) {
    return this.get<GetEventTypesByParentIdResponse>(`${this.apiUrl}/api/eventtypes/getByParentId`, {
      parentId,
    });
  }

  async getNotificationEventSubTypes(params: PaginationParams) {
    return this.get<GetNotificationEventSubTypesResponse>(`${this.apiUrl}/api/eventsubtypes/paged`, params);
  }

  async getNotificationEventSubTypesMapping(id: number) {
    return this.get<GetEventSubTypesMappingResponse>(`${this.apiUrl}/api/notificationcontrols/mapping/${id}`);
  }

  async controlNotification(req: ControlNotificationRequest) {
    return this.post<ControlNotificationResponse, ControlNotificationRequest>(
      `${this.apiUrl}/api/notificationcontrols`,
      req
    );
  }

  async controlMultiNotification(req: ControlMultiNotificationRequest) {
    return this.post<ControlMultiNotificationResponse, ControlMultiNotificationRequest>(
      `${this.apiUrl}/api/notificationcontrols/multi`,
      req
    );
  }
}
